module.exports = __webpack_public_path__ + "static/media/incomplete-team-example-mobile.5824d9e1.jpg";